const targetWidths = new WeakMap();

export { targetWidths };
